import { format, parse } from 'date-fns';
import React from 'react';
import { AnalyticsTrigger, Anchor, Grid, GridColumn, Heading, List, ListItem, Separator, Tag } from 'telia-front-react';
import { EMPLOYEE_CATEGORY } from '../../stores/SearchStore';
import { DealerNewsResult } from '../SearchInterfaces';
import { TranslationsContext } from '@teliaee/telia-translate';
import SearchResultRow from './SearchResultRow';

interface DealerSearchResultProps {
  result: DealerNewsResult;
  onClick: (item: any) => void;
  length: number;
  isArchived?: boolean;
}

const DealerSearchResult = (props: DealerSearchResultProps) => {
  const { date, modified } = props.result;
  const translate = React.useContext(TranslationsContext).translate;

  return (
    <SearchResultRow>
      <Separator spacing="small" weight="thin" />
      <List type="unstyled" direction="inline" bordered>
        <ListItem className="text-color-normal text-tiny">
          <Grid noWrap={['xs']} gutter={'xsmall'}>
            <GridColumn width={['min']}>
              <time>{format(parse(date, "yyyy-MM-dd'T'HH:mm:ss", Date.now()), 'dd.MM.yyyy HH:mm')}</time>
            </GridColumn>
            <GridColumn width={['max']}>
              <p>
                {date !== modified &&
                  translate('search.dealer.lastModified', { date: format(parse(modified, "yyyy-MM-dd'T'HH:mm:ss", Date.now()), 'dd.MM.yyyy HH:mm') })}
              </p>
            </GridColumn>
          </Grid>
        </ListItem>
        {props.result.authors.length > 0 ? <ListItem className="text-color-normal text-tiny">{props.result.authors.join(', ')}</ListItem> : null}
        {props.result.topics?.length > 0 ? (
          <Grid gutter="small" align={['middle-xs']} className="text-color-normal text-tiny">
            {props.result.topics.map((topic) => (
              <GridColumn width={['xs']} key={`${props.result.objectID}-tagColumn-${topic}`} align={['middle-xs']}>
                <Tag key={`${props.result.objectID}-tag-${topic}`} text={topic} purpose={'employee'} size={'tiny'} />
              </GridColumn>
            ))}
            {props.isArchived && (
              <GridColumn width={['xs']}>
                <Tag key="archived_tag" text={translate('newsSearchResults.tagArchived')} purpose="text" size={'tiny'} />
              </GridColumn>
            )}
          </Grid>
        ) : null}
      </List>
      <Heading element="h4">
        <AnalyticsTrigger
          trigger={{
            id: `Tab - ${EMPLOYEE_CATEGORY} - Link - ${props.result.title}`,
            callback: 'onClick'
          }}
        >
          <Anchor
            url={props.result.url}
            isTextColor={true}
            onClick={() => {
              props.onClick(props.result);
            }}
            className="text-weight-normal"
          >
            <span dangerouslySetInnerHTML={{ __html: props.result.title }} />
          </Anchor>
        </AnalyticsTrigger>
      </Heading>
      <p dangerouslySetInnerHTML={{ __html: props.result.content }} />
    </SearchResultRow>
  );
};

export default DealerSearchResult;
